'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import croppieModal from '../../modules/croppieModal';

const teamsMine = {
  init() {
    croppieModal.init();

    $('.js-btn-invite').on('click', function(e) {
      e.preventDefault();
      $('#js-invites').removeClass('u-display--none');
    });

    const $invites_container = $('[data-invites-container]');

    $('.o-form--invites').on('submit', function(e) {
      e.preventDefault();

      let url = $(this).attr('action');

      let email = $('#js-email').val();
      let _token = $('meta[name="csrf-token"]').attr('content');

      $.ajax({
        url: url,
        type: 'POST',
        data: { email: email, _token: _token },
        dataType: 'json',
        success: function(data) {
          if (data.success) {
            $invites_container.show();
            $('#js-email').val('');

            Swal.fire(
              'Convite enviado com sucesso!',
              'O usuário deverá realizar um cadastro na plataforma para contabilizar a pontuação da sua equipe.',
              'success'
            ).then(() => {
              $('[data-participants]')
                .removeClass('js-warning-available')
                .find('.s-teams--sidebar-steps-item-available')
                .removeClass('s-teams--sidebar-steps-item-available')
                .addClass('s-teams--sidebar-steps-item-completed');

              $('[data-quiz]')
                .removeClass('js-warning-closed')
                .addClass('js-warning-available')
                .attr('href', window.location.origin + '/quiz')
                .off()
                .find('.s-teams--sidebar-steps-item-closed')
                .removeClass('s-teams--sidebar-steps-item-closed')
                .addClass('s-teams--sidebar-steps-item-available');
            });

            let template = `
            <tr>
              <td>
                <p>${email}</p>
              </td>
              <td align="center">
                <p>Convite enviado.</p>
              </td>
            </tr>`;

            $('.js-invites-table').append(template);
          } else {
            Swal.fire('Atenção!', data.message, 'warning');
          }
        },
      });
    });
  },
};

export default teamsMine;
